import { Chip, Stack, SxProps, Theme, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { HeroSectionFormat } from '.';

interface HeroSectionRenderComponentProps {
  format: HeroSectionFormat;
  value?: string;
  variant: 'body1' | 'h3';
  sx?: SxProps<Theme>;
  children?: ReactNode;
}
const HeroSectionRenderComponent: FC<HeroSectionRenderComponentProps> = ({
  children,
  format,
  value,
  variant,
  sx,
}) => {
  switch (format) {
    case HeroSectionFormat.CHIP:
      return (
        <Stack direction="row" alignItems="center">
          {value && <Chip label={value} size="small" />}
          {children}
        </Stack>
      );
    case HeroSectionFormat.TYPOGRAPHY:
    default:
      return (
        <Typography variant={variant} sx={sx}>
          {value || '-'}
          {children}
        </Typography>
      );
  }
};

export default HeroSectionRenderComponent;
